const CANONICAL = new Set(['completed', 'failed', 'waiting', 'stopped']);

export function canonicalExecutionStatus(payload) {
  const raw = payload && typeof payload === 'object' ? payload.executionStatus : payload;
  if (raw == null || raw === '') return null;
  const value = String(raw).trim().toLowerCase();
  return CANONICAL.has(value) ? value : null;
}

export function executionStatusLabel(status) {
  switch (String(status || '').trim().toLowerCase()) {
    case 'completed':
      return 'Completed';
    case 'failed':
      return 'Failed';
    case 'waiting':
      return 'Waiting';
    case 'stopped':
      return 'Stopped';
    case 'running':
      return 'Running';
    default:
      return null;
  }
}

export function formatResumeAtLocal(resumeAt) {
  if (resumeAt == null || resumeAt === '') return null;
  const date = resumeAt instanceof Date ? resumeAt : new Date(resumeAt);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleString();
}

export function waitingDisplayLabel(resumeAt) {
  const local = formatResumeAtLocal(resumeAt);
  return local ? `Waiting until ${local}` : 'Waiting';
}

export function isFailedExecutionResult(payload) {
  if (!payload || typeof payload !== 'object') return false;
  if (canonicalExecutionStatus(payload) === 'failed') return true;
  return payload.success === false;
}

export function flowExecutionFailureMessage(payload) {
  if (!isFailedExecutionResult(payload)) return null;
  const results = payload?.details?.actionResults;
  if (Array.isArray(results)) {
    const failed = results.find((item) => item && item.success === false);
    if (failed?.message) return String(failed.message);
    if (failed?.error) return String(failed.error);
  }
  if (payload.error) return String(payload.error);
  if (payload.message && payload.message !== 'Flow execution completed') {
    return String(payload.message);
  }
  return 'Flow failed — one or more actions did not complete successfully.';
}

export function pickExecutionDebugFields(payload = {}) {
  const details = payload.details && typeof payload.details === 'object' ? payload.details : {};
  const runId = payload.runId || payload.flowRunId || details.runId || details.flowRunId || null;
  return {
    runId: runId ? String(runId) : null,
    flowRunId: payload.flowRunId || details.flowRunId || (runId ? String(runId) : null),
    executionStatus: canonicalExecutionStatus(payload),
    currentStepId: payload.currentStepId || details.currentStepId || null,
    nextStepId: payload.nextStepId || details.nextStepId || null,
    resumeAt: payload.resumeAt || details.resumeAt || null,
    error: payload.error || details.error || null,
  };
}
